import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';

export type ProLightEllipsisVerticalProps = IconComponentProps;

export const ProLightEllipsisVertical = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightEllipsisVerticalProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faEllipsisVertical}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faEllipsisVertical}
    />
  );
};

ProLightEllipsisVertical.displayName = 'ProLightEllipsisVertical';
